import React, { useEffect, useState } from 'react';
import CalculatorTrigger from './CalculatorTrigger';
import CalculatorPanel from './CalculatorPanel';
import { useExamContext } from '../../context/ExamContext';
import './Calculator.css';

export default function Calculator() {
  const ctx = useExamContext();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (ctx?.activeWidget === 'calculator') {
      setIsOpen(true);
    } else if (ctx?.activeWidget !== 'calculator' && isOpen) {
      setIsOpen(false);
    }
  }, [ctx?.activeWidget]);

  const handleToggle = () => {
    if (isOpen) {
      ctx?.setActiveWidget?.(null);
    } else {
      ctx?.setActiveWidget?.('calculator');
    }
  };

  return (
    <>
      <div className={`calc-wrapper ${isOpen ? 'calc-wrapper--open' : ''}`}>
        <CalculatorPanel isOpen={isOpen} />
      </div>
      <CalculatorTrigger onClick={handleToggle} isOpen={isOpen} />
    </>
  );
}
